<script lang="ts">
    import productsStore from '../store/product';
    import { getUrlParam } from '../helpers/url';
    import lang from '../lang/language';
    import Datepicker from './Datepicker.svelte';
    import { date, night, guest, shoppingCategory } from '../store/search';
    import { onMount } from 'svelte';
    import jQuery from 'jquery';
    import { OAshortname, shortname } from '../helpers/consts';
    import { getPriceAvailabilityText } from '../helpers/common';

    let id = getUrlParam('id');

    export let serviceType;
    export let onRequest;

    let criteria: any = { Id: id };

    let showGuestWarning = false;

    $: {
        //reset
        criteria = { Id: id, Type: serviceType };

        if ($date) {
            criteria.Date = $date;
        }
        if ($night) {
            criteria.Night = $night;
        }
        if ($guest) {
            criteria.Guest = $guest;
        }
        if ($shoppingCategory) {
            criteria.ShoppingCategory = $shoppingCategory;
        }
    }

    function search() {
        if ($guest > 0) {
            showGuestWarning = false;
            productsStore.search(
                criteria,
                getUrlParam('on_req') === 'true' ? OAshortname : shortname
            );
        } else {
            showGuestWarning = true;
        }
    }

    onMount(() => {
        if (serviceType == 3) {
            jQuery('.search-button').click();
        }
    });
</script>

<div class="search-wrapper">
    <h2 class="nara-season font check-price">
        {getPriceAvailabilityText(serviceType)}
    </h2>
    <div class="form-wrapper">
        <div class="filter-wrapper">
            {#if serviceType !== 3}
                <div class="row" style="margin-right:10px">
                    <div class="input-wrapper icon calendar">
                        <Datepicker placeholder={lang.date} {onRequest} />
                    </div>
                </div>
            {/if}
            {#if serviceType === 0}
                <div class="row" style="margin-right:10px">
                    <div class="input-wrapper icon night">
                        <input
                            bind:value={$night}
                            class="input-field"
                            type="number"
                            min="1"
                            placeholder={lang.night}
                        />
                    </div>
                </div>
            {/if}

            {#if serviceType === 3}
                <div class="row" style="margin-right:10px">
                    <div class="input-wrapper icon category">
                        <select
                            class="input-field"
                            type="text"
                            placeholder="Choose Keyword"
                            bind:value={$shoppingCategory}
                        >
                            <option value=""
                                >{lang.search_all_categories}</option
                            >
                            <option value={lang.dairy}>{lang.dairy}</option>
                            <option value={lang.sweet}>{lang.sweet}</option>
                            <option value={lang.wine}>{lang.wine}</option>
                        </select>
                    </div>
                </div>
            {/if}
            <div
                class="row"
                style={`margin-right:10px; display: ${
                    serviceType === 3 ? 'none' : 'block'
                }`}
            >
                <div
                    class={`input-wrapper icon ${
                        serviceType === 3 ? 'shopping' : 'guest'
                    }`}
                >
                    <input
                        bind:value={$guest}
                        class="input-field"
                        type="number"
                        min="1"
                        placeholder={lang.guest}
                    />
                </div>
            </div>
        </div>

        <div class="row text-center">
            <button
                class="reqBtn border-0"
                style="max-width:130px; height:50px; cursor: pointer"
                on:click={search}
            >
                <span class="text-uppercase">{lang.search_button}</span>
            </button>
            {#if showGuestWarning}
                <span class="red-text">{lang.guest_warning}</span>
            {/if}
        </div>
    </div>
</div>

<style>
    .check-price {
        margin: 0;
        text-align: left;
        font-weight: bold;
    }
    .subtitle,
    .subsubtitle {
        text-align: left;
    }

    .reqBtn span {
        width: 100%;
        height: 100%;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: center;
        justify-content: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 2.4rem;
        letter-spacing: 0.12em;
        font-weight: 400;
        color: #fff;
        background-color: #be5a14;
        position: relative;
        background-color: #b76657;
        /*color: #000;*/
    }

    .subtitle {
        background-color: #dba912;
        color: white;
        font-weight: bold;
        color: white;
        padding: 5px 10px;
        letter-spacing: 2px;
    }

    .subsubtitle {
        padding: 15px 5px;
    }

    .search-wrapper {
        text-align: center;
    }

    .form-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 5px;
    }

    .filter-wrapper {
        display: flex;
        align-items: center;
    }

    .input-field {
        padding: 0;
    }

    .icon {
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 20px;
        padding-left: 40px;
    }

    .category {
        background-image: url('../icons/category.png');
    }

    .price {
        background-image: url('../icons/price.png');
    }

    .keyword {
        background-image: url('../icons/keyword.png');
    }

    .calendar {
        background-image: url('../icons/calendar.png');
        max-width: 200px;
    }

    .night {
        background-image: url('../icons/night.png');
        max-width: 100px;
    }

    .guest {
        background-image: url('../icons/guest.png');
        max-width: 100px;
    }
    .shopping {
        background-image: url('../icons/shopping.png');
        max-width: 100px;
    }

    @media screen and (max-width: 900px) {
        .form-wrapper {
            flex-direction: column;
            gap: 2px;
        }
    }
</style>
